import { useTranslation } from "react-i18next";
import { Block } from "./shared/Block";
import { FileUploadDropzone } from "@/components/upload/FileUploadDropzone";
import { useAddImageObject } from "@/components/canvas/hooks/event/useAddImageEvent";
import { getContentFullUrl } from "@/lib/contentUtils";
import { showSuccess, showApiError } from "@/lib/toast";
import { uploadWithoutContent } from "@/sideEffects/api";
import { useMutation } from "@tanstack/react-query";
import { selectActiveFirm } from "@/store/appSelectors";
import { useSelector } from "react-redux";

export const MediaLibraryInspector = () => {
  const { t } = useTranslation();
  const dispatchAddImage = useAddImageObject();
  const activeFirm = useSelector(selectActiveFirm);

  const uploadMutation = useMutation({
    mutationFn: (file: File) =>
      uploadWithoutContent({
        firmGuid: String(activeFirm?.firmGuid),
        files: [file],
        name: file.name,
      }),
    onSuccess: (data) => {
      if (!data.data) return;
      const imageUrl = getContentFullUrl(data.data.value.contentStorageName);
      console.log("imageUrl", imageUrl);
      dispatchAddImage({ imageUrl });
      showSuccess(t("common.imageUploaded"));
    },
    onError: showApiError,
  });

  return (
    <div>
      <Block title={t("template.inspector.mediaLibrary")}>
        <FileUploadDropzone
          onClickUpload={(files) => uploadMutation.mutate(files[0])}
          dropzoneOptions={{
            maxFiles: 1,
            accept: {
              "image/*": [".png", ".jpg", ".jpeg"],
            },
          }}
          isLoading={uploadMutation.isPending}
        />
      </Block>
    </div>
  );
};
